import { BaseError } from './base-error';

export class DeleteReferencedDataError extends BaseError {
	get items() {
		return this.errorResult.allMessages;
	}
}
